var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.678 7.45264L7.51942 7.45264C6.33978 7.45264 5.19805 7.91599 4.3608 8.76564C3.52356 9.61528 3.04788 10.7545 3.06696 11.971C3.04783 13.1875 3.52369 14.3269 4.3608 15.1764C5.21701 16.0453 6.32063 16.5088 7.50032 16.5088H10.6589M14.6548 16.5474H17.8134C18.993 16.5474 20.1348 16.084 20.972 15.2344C21.8093 14.3847 22.2849 13.2455 22.2659 12.029C22.2659 10.8319 21.7902 9.69263 20.9529 8.84298C20.1157 7.99333 18.9931 7.51062 17.8134 7.5106H14.6548M7.91885 11.9578L17.3946 11.9578",
    stroke: "black",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.bd993720acc7325ed40b4eb1bf097c30.svg";
export { ForwardRef as ReactComponent };